var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ptInitData.productInfo.CATCH_COPY != undefined)?_c('p',{staticClass:"catchCopy sort-item",domProps:{"innerHTML":_vm._s(_vm.ptInitData.productInfo.CATCH_COPY)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }